import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconLaptop$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLaptop extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5ab0d72fd913d26312fb384d9388c2f5de69b0f9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'cfb934e24563fbed9f159fc6032d2a3da20aa965', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4ee733f02994cbf51b021e9de86b895e3de952f2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4 6.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5V15H4zm12.5 1v6h-11v-6zM20 16H2v1a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-laptop", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-laptop"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-laptop":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLaptop$1);
            }
            break;
    } });
}

const CosmosIconLaptop = CosmosIconLaptop$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLaptop, defineCustomElement };
